export default "__VITE_ASSET__13f998f4__"